module.exports = __webpack_public_path__ + "static/media/MENU.7cdb99ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MENU.jpg
// module id = 464
// module chunks = 0